import React, { createContext, useContext } from 'react';

import { useFocusToggle } from './use-focus-toggle';
import { useTabNavigationWatcher } from './use-tab-navigation-watcher';

interface IAccessibilityContext {
  /**
   * Whether or not a user is using tabs for navigating the page
   */
  isUsingTabNavigation: boolean;
}

export const AccessibilityContext = createContext<IAccessibilityContext>({
  isUsingTabNavigation: false
});

/**
 * Provides accessibility utilities
 */
export const useAccessibility = () => useContext(AccessibilityContext);

/**
 * Provides accessibility utilities
 */
export const AccessibilityProvider: React.FC = ({ children }) => {
  const { isUsingTabNavigation } = useTabNavigationWatcher();

  const { FocusToggleStyles } = useFocusToggle(isUsingTabNavigation);

  return (
    <AccessibilityContext.Provider
      value={{
        isUsingTabNavigation
      }}
    >
      <FocusToggleStyles />
      {children}
    </AccessibilityContext.Provider>
  );
};
